// extracted by mini-css-extract-plugin
export default {"btn":"UiDemo_btn__np9j1","grid":"UiDemo_grid__ypLM-"};